exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-ed78856c]{width:100%;height:100%;background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:start}.img[data-v-ed78856c]{width:200px;height:200px;margin-bottom:20px}.text[data-v-ed78856c]{margin-bottom:50px;color:#4a494b;font-weight:600;font-size:16px}.btn[data-v-ed78856c]{width:220px;height:40px;line-height:40px;border-radius:10px;background:#3566e8;color:#fff;font-size:14px;text-align:center;letter-spacing:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ed78856c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/empowerOver/empowerOver.vue
// module id = lUtL
// module chunks = 1